import { render } from "./CorporatePlanSuccess.vue?vue&type=template&id=570245f6"
import script from "./CorporatePlanSuccess.vue?vue&type=script&lang=js"
export * from "./CorporatePlanSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__